import { at } from "lodash";
import { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import { useField, useFormikContext } from "formik";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

export default function BasicDateTimePicker(props: any) {
  const { disabled, errorText, label, name, ...rest } = props;
  
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  const [displayValue, setDisplayValue] = useState<Date | null>(field.value);
  const [initialValue, setInitialValue] = useState<Date | null>(field.value);

  useEffect(() => {
    setInitialValue(field.value);
  }, [field.value]);

  const handleChange = (newValue: Date | null) => {
    if (newValue) {
      const adjustedValue = new Date(newValue.getTime() - newValue.getTimezoneOffset() * 60000);
      setFieldValue(field.name, adjustedValue);
      setDisplayValue(newValue);
    } else {
      setFieldValue(field.name, null);
      setDisplayValue(null);
    }
  };

  const renderHelpText = () => {
    const [touched, error] = at(meta, "touched", "error");
    if (touched && error) {
      return error;
    }
  };

  const dateId = `${name}-date`;
  const timeId = `${name}-time`;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        inputFormat="dd/MM/yyyy hh:mm aa"
        value={displayValue}
        onChange={handleChange}
        label={label}
        disabled={props.disabled} 
        renderInput={(params: any) => {
          return (
            <TextField
              {...params}
              {...rest}
              InputLabelProps={{ shrink: true }}
              disabled={disabled}
              error={meta.touched && meta.error && true}
              helperText={renderHelpText()}
              fullWidth
              onBlur={() => {
                if (!displayValue) {
                  setDisplayValue(initialValue);
                }
              }}
              inputProps={{
                ...params.inputProps,
                id: `${name}-datetime`,                
                'data-date-id': dateId,
                'data-time-id': timeId                
              }}
            />
          );
        }}
      />
    </LocalizationProvider>
  );
}
